import { render, staticRenderFns } from "./MyCommunityInfo.vue?vue&type=template&id=3d808235&scoped=true&"
import script from "./MyCommunityInfo.vue?vue&type=script&lang=js&"
export * from "./MyCommunityInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyCommunityInfo.vue?vue&type=style&index=0&id=3d808235&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d808235",
  null
  
)

export default component.exports